import {
  TOGGLE_VISIBILITY,
  UPDATE_SETTING,
  SET_REDIRECTION_SETTINGS,
  SET_HMT_MUTATION
} from "./constants.js";

export default {
  [TOGGLE_VISIBILITY](state) {
    state.showSettingsEditor = !state.showSettingsEditor;
  },
  [UPDATE_SETTING](state, newSettings) {
    Object.assign(state, newSettings);
  },
  [SET_REDIRECTION_SETTINGS](state, { filename, customerId, redirectUrl, callbackUrl }) {
    state.redirectAfterSave = true;
    state.fileToEdit = filename;
    state.customerId = customerId;
    state.redirectUrlAfterSave = redirectUrl;
    state.callbackUrlAfterSave = callbackUrl;
  },
  [SET_HMT_MUTATION](state, newHmtSettings) {
    state.useHmt = newHmtSettings;
  }
};
